<template>
  <div class="clearfix">
    <span
      v-for="asiento in asientosLibres"
      :key="asiento"
      class="asiento-control label clickable m-r-sm pull-left"
      :class="{ 'label-white': asiento != modelValue, 'label-cifra': asiento == modelValue }"
      @click="seleccionarAsiento(asiento)"
    >
      {{ asiento }}
    </span>
    <span
      v-if="!asientosLibres.length"
      class="form-control"
    >
      {{ $I18n.t('asientos_no_disponibles') }}
    </span>
  </div>
</template>

<script>
import { transporte } from 'cifra-api-js';
import { isValidDate } from '../../../libs/dates';

export default {
  props: {
    turnoId: { type: [Number, Array], default: () => [] },
    fechaInicio: { type: String, default: null },
    fechaFin: { type: String, default: null },
    conservarAsientoInicial: { type: Boolean, default: true },
    modelValue: { type: Number, default: null },
  },
  data() {
    return {
      asientoFijo: this.conservarAsientoInicial ? this.modelValue : null,
      asientosLibres: [],
    };
  },
  watch: {
    turnoId() {
      this.loadAsientos();
    },
    fechaInicio() {
      this.loadAsientos();
    },
    fechaFin() {
      this.loadAsientos();
    },
  },
  mounted() {
    this.loadAsientos();
  },
  methods: {
    loadAsientos() {
      if (!this.turnoId) {
        return;
      }

      let turnoIds;
      if (Array.isArray(this.turnoId)) {
        turnoIds = this.turnoId;
      } else {
        turnoIds = [this.turnoId];
      }

      if (!turnoIds.length || !isValidDate(new Date(this.fechaInicio))) {
        return;
      }

      transporte.turnos.asientosLibres(turnoIds, this.fechaInicio, this.fechaFin).then((result) => {
        this.asientosLibres = result.data.asientos_libres;
        if (this.asientoFijo) {
          this.anadirAsiento(this.asientoFijo);
        }

        if (this.modelValue) {
          if (!this.asientosLibres.includes(this.modelValue)) {
            // Si se recarga y ya no existe el asiento inicial, eliminamos el valor
            this.$emit('update:modelValue', null);
          }
        }
      });
    },
    anadirAsiento(numero) {
      if (!this.asientosLibres.includes(numero)) {
        this.asientosLibres.push(numero);
        this.asientosLibres = this.asientosLibres.sort((a, b) => a - b);
      }
    },
    seleccionarAsiento(asiento) {
      this.$emit('update:modelValue', asiento);
    },
  },
};
</script>
